<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <div
            v-bind="tooltip.attrs"
            v-on="analise.disabled && tooltip.on"
            class="title-btn"
          >
            <v-btn
              v-on="on"
              outlined
              :color="analise.color"
              :disabled="analise.disabled"
              class="mr-3"
            >
              <slot name="title"></slot>
            </v-btn>
          </div>
        </template>
        É necessáro o preenchimento das informações obrigatórias nos dados
        cadastrais.
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="onClose" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <template v-if="analise.iniciar">
          <v-row>
            <v-col>
              <h3>O envio do contrato assinado é obrigatório.</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-file-input
                accept="application/pdf, application/vnd.ms-excel"
                label="Contrato assinado*"
                v-model="analise.minuta"
                hide-details="auto"
              >
              </v-file-input>
            </v-col>
          </v-row>
        </template>
        <template v-else-if="analise.aceitar">
          <v-row>
            <v-col>
              <strong
                >Custo do Investimento Municipal
                {{
                  payload.investimentoMunicipio &&
                  payload.investimentoMunicipio.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}</strong
              >
            </v-col>
          </v-row>
          <v-form ref="form">
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="analise.parcelas"
                  label="SELECIONE A QUANTIDADE DE PARCELAS"
                  placeholder="Selecione.."
                  :items="getParcelas(payload.investimentoMunicipio)"
                  item-text="label"
                  item-value="value"
                  hide-details="auto"
                  :return-object="true"
                  @change="criarDatas"
                  :rules="[obrigatorio]"
                >
                  <template slot="no-data">
                    Nenhuma parcela retornada
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0">
              <v-col>
                <v-data-table
                  :headers="headers"
                  :items="parcelas"
                  class="elevation-1 w-100 proposta"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:item.parcela="{ item }">
                    <v-col> {{ item.parcela }} </v-col>
                  </template>

                  <template v-slot:item.custo="{ item }">
                    <v-col>
                      {{
                        item.valor.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </v-col>
                  </template>

                  <template v-slot:item.dataVencimento="{ item }">
                    <v-col>
                      <v-text-field
                        v-model="item.dataVencimento"
                        outlined
                        label="Data de Vencimento"
                        name="data vencimento"
                        type="text"
                        hide-details="auto"
                        v-mascara="'##/####'"
                        placeholder="MM/AAAA"
                        :rules="[obrigatorio, carencia]"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-else-if="analise.baixarMinuta">
          <v-row>
            <v-col>
              <h3>
                É necessário adicionar ao menos um representante do SEBRAE/SC
                para gerar a minuta do contrato.
              </h3>
            </v-col>
          </v-row>

          <v-row v-if="payload.investimentoMunicipio < 92000">
            <v-col>
              <ComboboxGerente
                :filter="analise.gerente1"
                :title="'Representante do SEBRAE/SC 1'"
                @onChange="(e) => addGerente(e, 1)"
                :defaultRepresentante="representante1Atual"
                :disabled="
                  analise.status == statusPropostasEnum.execucaoIniciada
                "
              ></ComboboxGerente>
            </v-col>
            <v-col>
              <ComboboxGerente
                :filter="analise.gerente2"
                :title="'Representante do SEBRAE/SC 2'"
                @onChange="(e) => addGerente(e, 2)"
                :defaultRepresentante="representante2Atual"
                :disabled="
                  analise.status == statusPropostasEnum.execucaoIniciada
                "
              ></ComboboxGerente>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col>
              <v-textField
                label="Representante do SEBRAE/SC 1"
                v-model="analise.nomeRepresentante1"
                hide-details="auto"
                disabled
              >
              </v-textField>
            </v-col>
            <v-col>
              <v-textField
                label="Representante do SEBRAE/SC 2"
                v-model="analise.nomeRepresentante2"
                hide-details="auto"
                disabled
              >
              </v-textField>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <h3>Deseja adicionar uma justificativa a recusa da proposta?</h3>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                label="Justificativa"
                v-model="analise.justificativaRecusa"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn color="error" outlined text @click="onClose">Fechar</v-btn>
        <v-btn
          color="info"
          outlined
          text
          @click="onConfirm"
          :disabled="salvarDisabled"
        >
          <slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { propostaApi, municipioPropostaParcelasApi } from "@/apis/proposta";
import { statusPropostasEnum } from "@/modules/city/components/propostas/statusPropostasEnum";
import moment from "moment";
import TabelaValores from "@/modules/city/components/propostas/ma/TabelaValoresMA.vue";
import ComboboxGerente from "@/modules/ur/components/ComboboxGerentes";
import { dataRegexValidatior } from "@/helpers/validator";

export default {
  name: "ModalAnalisarProposta",
  components: {
    TabelaValores,
    ComboboxGerente,
  },
  props: {
    payload: { type: Object, required: true },
    faixa: { type: Object, default: null },
    combos: { type: Array, default: () => [] },
    config: { type: Array, default: () => [] },
  },
  data() {
    return {
      dialog: false,
      items: [1, 2],
      representante1Atual: null,
      representante2Atual: null,
      analise: this.payload,
      statusPropostasEnum: statusPropostasEnum,
      parcelas: [],

      headers: [
        {
          text: "N° da Parcela",
          value: "parcela",
          align: "center",
          width: "10%",
          sortable: false,
        },
        { text: "Valor", value: "custo", align: "center" },
        {
          text: "Data de Vencimento",
          value: "dataVencimento",
          align: "center",
        },
      ],
      obrigatorio: (v) => !!v || "Campo Obrigatório",
      carencia: (v) => {
        const dataVencimento = moment(`10/${v}`, "DD/MM/YYYY");
        const carencia60dias = moment().add(60, "days");

        if (!dataRegexValidatior.test(`10/${v}`) || v.length < 7) {
          return "Data inválida";
        }

        if (dataVencimento.isSameOrAfter(carencia60dias)) return true;

        return `A data precisa ser maior que ${carencia60dias.format(
          "MM/YYYY"
        )}`;
      },
      rules: [this.obrigatorio, this.carencia],
      headersAnexos: [
        {
          text: "Nome do arquivo",
          value: "filename",
          align: "center",
          width: "10%",
          sortable: false,
        },
        { text: "Excluir", value: "excluir", align: "center" },
      ],
    };
  },
  watch: {
    payload: {
      handler(val) {
        this.analise = val;
        if (val.investimentoMunicipio > 92000) {
          const diretor1 = this.config.find(
            (item) => item.configuracaoId == 11
          );
          const diretor2 = this.config.find(
            (item) => item.configuracaoId == 12
          );
          this.analise.nomeRepresentante1 = diretor1.nome;
          this.analise.cpfRepresentante1 = diretor1.valor;
          this.analise.nomeRepresentante2 = diretor2.nome;
          this.analise.cpfRepresentante2 = diretor2.valor;
        }
        var indexCPf1 =
          this.analise.nomeRepresentante1 &&
          this.analise.nomeRepresentante1.indexOf("-");

        var indexCPf2 =
          this.analise.nomeRepresentante1 &&
          this.analise.nomeRepresentante2.indexOf("-");

        this.representante1Atual = `${
          indexCPf1 > 0
            ? this.analise.nomeRepresentante1.substring(0, indexCPf1 - 1)
            : this.analise.nomeRepresentante1
        } `;

        this.representante2Atual = `${
          indexCPf2 > 0
            ? this.analise.nomeRepresentante2.substring(0, indexCPf2 - 1)
            : this.analise.nomeRepresentante2
        } `;

        this.analise.cpfRepresentante1 = `${
          indexCPf1 > 0
            ? this.analise.nomeRepresentante1.substring(indexCPf1 + 2)
            : ""
        } `;

        this.analise.cpfRepresentante2 = `${
          indexCPf2 > 0
            ? this.analise.nomeRepresentante2.substring(indexCPf2 + 2)
            : ""
        } `;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["user"]),
    salvarDisabled() {
      if (this.analise.iniciar && !this.analise.minuta) {
        return true;
      }

      if (
        this.analise.baixarMinuta &&
        !this.analise.nomeRepresentante1 &&
        !this.analise.nomeRepresentante2
      ) {
        return true;
      }

      return false;
    },
  },
  methods: {
    async check() {
      if (!this.$refs.form) return true;
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    criarDatas(e) {
      const valor = e.value;
      this.parcelas = Array.from({ length: e.value }).map((item, index) => {
        const atual = index + 1;
        return {
          dataVencimento: null,
          municipioid: this.$route.params.id,
          propostaId: this.payload.municipioPropostaId,
          valor: this.payload.investimentoMunicipio / valor,
          parcela: atual,
          dataCriacao: moment().format("YYYY-MM-DD HH:mm:ss"),
        };
      });
    },
    addParcelas() {
      this.parcelas = this.parcelas.map((item) => ({
        ...item,
        dataVencimento: moment(
          `10/${item.dataVencimento}`,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD HH:mm:ss"),
      }));

      municipioPropostaParcelasApi
        .add(this.parcelas)
        .then(() => {
          this.$emit("onLoad");

          this.dialog = false;
        })
        .catch((err) => {
          this.$notification.error("Erro ao salvar parcelas");
          console.log("Erro no salvar parcelas ", err);
          this.setLoading(false);
        });
    },
    addGerente(e, type) {
      if (type == 1) {
        this.analise.nomeRepresentante1 = e.gerente;
        this.analise.cpfRepresentante1 = e.cpf;
      } else {
        this.analise.nomeRepresentante2 = e.gerente;
        this.analise.cpfRepresentante2 = e.cpf;
      }
    },
    onClose() {
      this.analise = {
        ...this.analise,
        contratoAssinado: null,
        termoAssinado: null,
        parcelas: null,
        nomeRepresentante1: null,
        nomeRepresentante2: null,
      };
      this.dialog = false;
    },
    ...mapActions(["setLoading"]),
    getParcelas(valorTotal) {
      const qtdParcela = [1, 2, 3, 4, 5, 6, 10, 12, 15];

      const a = qtdParcela.map((item) => {
        const qtdParcelaAtual = item;
        const parcelado = valorTotal / qtdParcelaAtual;

        return {
          label: `${qtdParcelaAtual}x de  ${(
            Math.ceil(parcelado * 100) / 100
          ).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}`,
          value: qtdParcelaAtual,
        };
      });

      return a;
    },
    qtdParcelas(d1, d2) {
      // até novembro de 2026
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months + 1;
    },
    salvarAnexos() {
      let formData = new FormData();

      formData.append("minuta", this.analise.minuta);
      formData.append("municipioPropostaId", this.analise.municipioPropostaId);
      formData.append("municipioId", this.analise.municipioId);
      formData.append("usuarioCriacao", this.user.usuarioId);
      formData.append("usuarioEnvioMinuta", this.user.usuarioId);

      propostaApi
        .enviarAnexo(formData)
        .then((item) => {
          this.update();
        })
        .catch((err) => {
          this.$notification.error("Erro ao salvar anexo");
          console.log("Erro no salvar anexo ", err);
          this.setLoading(false);
        });
    },
    update() {
      delete this.analise.nomeArquivo;
      delete this.analise.pastaArquivoMinuta;

      propostaApi
        .update(this.analise)
        .then(() => {
          if (this.analise.baixarMinuta) {
            this.$emit("baixarMinuta");
          } else if (
            this.analise.aceitar &&
            this.parcelas &&
            this.parcelas.length > 0
          ) {
            this.addParcelas();
          } else {
            this.$emit("onLoad");
          }

          this.dialog = false;
        })
        .catch((err) => {
          this.$notification.error("Erro ao analisar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    async onConfirm() {
      const valid = await this.check();
      if (!valid) return;

      this.setLoading(true);
      if (this.analise.aceitar || this.analise.rejeitar) {
        this.analise.dataAnalise = moment().format("YYYY-MM-DD HH:mm:ss");
        this.analise.qtdParcelas =
          (this.analise &&
            this.analise.parcelas &&
            this.analise.parcelas.value) ||
          null;
        this.analise.usuarioAnalise = this.user.usuarioId;
      }
      if (this.analise.aceitar)
        this.analise.status = statusPropostasEnum.aprovado;
      if (this.analise.rejeitar)
        this.analise.status = statusPropostasEnum.rejeitado;
      if (this.analise.iniciar) {
        this.analise.dataExecucao = moment().format("YYYY-MM-DD HH:mm:ss");
        this.analise.status = statusPropostasEnum.execucaoIniciada;
        this.analise.usuarioExecucao = this.user.usuarioId;
      }
      if (
        this.analise.baixarMinuta &&
        this.analise.status != statusPropostasEnum.execucaoIniciada
      ) {
        var indexCPf1 = this.analise.nomeRepresentante1.indexOf("-");

        var indexCPf2 = this.analise.nomeRepresentante2.indexOf("-");

        this.analise.nomeRepresentante1 = `${
          indexCPf1 > 0
            ? this.analise.nomeRepresentante1.substring(0, indexCPf1 - 1)
            : this.analise.nomeRepresentante1
        } - ${this.analise.cpfRepresentante1}`;
        this.analise.nomeRepresentante2 = `${
          indexCPf2 > 0
            ? this.analise.nomeRepresentante2.substring(0, indexCPf2 - 1)
            : this.analise.nomeRepresentante2
        } - ${this.analise.cpfRepresentante2}`;
      }

      if (this.analise.iniciar) {
        this.salvarAnexos();
      } else {
        this.update();
      }
    },
  },
};
</script>
<style lang="scss">
.title-btn {
  max-width: 150px;
  white-space: normal;
  margin: 10px 0;

  .v-btn {
    width: 100%;
    height: 100% !important;
    padding: 5px 16px !important;
    .v-btn__content {
      width: 100%;
      white-space: normal;
    }
  }
}
</style>
